<template>
  <div>{{name}}</div>
</template>

<script>
export default {
  data() {
    return {
        name:"普惠商城"
    };
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped></style>